// The recording test page's client (docs/ACTIONS-2026-09-17.md B1). Mirrors
// apps/api/src/twilio/routes.ts; nothing here decides what the API did not. Its own fetch helpers,
// as the super-admin surface keeps its own, so this page is worked on apart; the error classes are
// shared so a signed-out caller is sent to sign in from wherever it was.
import { viewFetch as fetch } from '../view-as.js';
import { ApiError, Unauthenticated } from '../api.js';

async function json<T>(res: Response): Promise<T> {
  if (res.status === 401) throw new Unauthenticated();
  if (!res.ok) {
    const said = await res.json().then((b: unknown) => (typeof b === 'object' && b !== null && typeof (b as { error?: unknown }).error === 'string' ? (b as { error: string }).error : null)).catch(() => null);
    throw new ApiError(res.status, said ?? `${res.status} ${res.statusText}`);
  }
  return (await res.json()) as T;
}
const get = <T>(path: string) => fetch(path, { credentials: 'same-origin' }).then((r) => json<T>(r));
const post = <T>(path: string) => fetch(path, { method: 'POST', credentials: 'same-origin' }).then((r) => json<T>(r));

/** POST /api/twilio/token. The token goes to the Voice SDK and nowhere else; it is never shown. */
export interface TokenView { token: string; identity: string; ttl: number; expiresAt: string; callerId: string }

export interface RecordingEvent {
  recordingSid: string; status: string; durationSeconds: number | null; channels: number | null;
  source: string | null; startTime: string | null; errorCode: string | null; receivedAt: string;
}
export interface TestCall { callSid: string; identity: string | null; applicationSid: string | null; startedAt: string | null; recordings: RecordingEvent[] }
export interface Readiness { credentials: boolean; number: boolean; twimlApp: boolean; callbackVerification: boolean; missing: string[]; canCall: boolean }
export interface Refusal { route: 'voice' | 'recording-status'; reason: string; at: string }
/** GET /api/twilio/test/status. */
export interface TestStatusView { readiness: Readiness; callerId: string | null; identity: string; calls: TestCall[]; refusals: { count: number; last: Refusal | null } }

export const twilioTest = {
  token: () => post<TokenView>('/api/twilio/token'),
  status: () => get<TestStatusView>('/api/twilio/test/status'),
};

/** E.164 as the API accepts it: + then 7 to 15 digits, no spaces. Spaces and dashes typed are dropped first. */
export const E164 = /^\+[1-9][0-9]{6,14}$/;
export function tidyNumber(typed: string): string {
  return typed.replace(/[\s\-().]/g, '');
}
